/// <amd-module name="Artifacts/Root/types/IRoutableComponentProps" />
export interface IRoutableComponentProps {
  navigateToRoute: (route: string) => void;
}
